class QuickBuy extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.setupModal = this.setupModal.bind(this)
    this.handleTrigger = this.handleTrigger.bind(this)
    this.hideQuickBuy = this.hideQuickBuy.bind(this)
    this.handleClose = this.handleClose.bind(this)

    this.listeners.add(window, `load`, this.setupModal)
    this.listeners.add(document, `click`, this.handleTrigger)
    this.listeners.add(this.els.close.element, `click`, this.handleClose)
  }

  setupModal () {
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.BEFORE_ADD_FROM_FORM,
      this.hideQuickBuy,
    )

    this.addEventListener(`click`, e => {
      if (e.target !== this) return

      this.setAttribute('aria-hidden', 'true')
    })
  }

  async handleTrigger (event) {
    const trigger = event.target.closest(
      '[data-quick-buy-external-el="trigger"]',
    )
    if (!trigger) return

    this.setAttribute('aria-hidden', 'true')

    await window.BAO.sectionRenderer
      .fetchSingle('quick-buy', trigger.dataset.productUrl)
      .then(res => {
        const sectionHTML = window.BAO.sectionRenderer.getInnerHtml(res)

        this.els.content.element.innerHTML = sectionHTML

        window.drawers.activeDrawerKey = ''
        document.body.classList.add('util-HideChat')
        this.setAttribute('aria-hidden', 'false')
      })
      .catch(() => {
        document.body.classList.remove('util-HideChat')
        this.setAttribute('aria-hidden', 'true')
      })
  }

  hideQuickBuy () {
    this.setAttribute('aria-hidden', 'true')
  }

  handleClose () {
    this.setAttribute('aria-hidden', 'true')
    document.body.classList.remove('util-HideChat')
  }
}

if (!customElements.get('quick-buy')) {
  customElements.define('quick-buy', QuickBuy)
}
